<!--头部导航-->
<template>
  <div class="container" style="background-color: #2e3458; min-width: 1349px">
    <div class="logo">
      <img src="@/assets/images/logo.png" alt />
    </div>
    <div class="module">
      <!--<el-menu router class="el-menu-demo" mode="horizontal" @select="topTab">
          <el-menu-item :index="item.path" v-for='(item,ind) in headItem'>{{item.tittle}}</el-menu-item>
      </el-menu>-->
      <!-- <div :class="{'tabActive':topActive===ind}" class="item" @click="topTab(ind,item)" v-for="(item,ind) in headItem" :key="ind">
        {{item.tittle}}
        <div :class="{'active':topActive===ind}"></div>
      </div> -->
      <nav class="nav" ref="mainHeader">
        <template v-for="(item, ind) in headItem">
          <span
            class="nav-item"
            style="{ position: relative}"
            :class="{ navActive: topActive == ind }"
            @click="topTab(ind, item)"
            v-if="item.tittle.indexOf('行业专区') == -1"
            :key="ind"
          >
            {{ item.tittle }}
            <!-- <img style="position:absolute;top:17px;right:-41px" v-if="item.tittle == '订单关怀'" src="@/assets/images/icon_home.png" alt="" /> -->
          </span>
          <span
            v-else-if="item.tittle == '行业专区预览页'"
            class="nav-item"
            style="position: relative;padding-right: 40px"
            @click="toIndustryPreview"
            :key="ind+'1'"
          >
            行业专区
            <img style="position:absolute;top:17px;right:0px" src="@/assets/images/newN.svg" alt="" />
          </span>
          <span
            v-else
            class="nav-item"
            style="position: relative;padding-right: 40px"
            @click="toOther(item)"
            :key="ind+''"
          >
            行业专区
            <img style="position:absolute;top:17px;right:0px" v-if="item.tittle == '行业专区'" src="@/assets/images/newN.svg" alt="" />
          </span>
        </template>
        <!-- <span v-if="navIogo" @click="handleUrl()" style="padding-top: 7px;" class="nav-item navLeft"
          ><img style="width:100px" src="@/assets/images/shy.gif" alt=""
        /></span> -->
        
        <span @click="handleLink(val)" class="nav-item nav-pcImgUrl" v-for="val in popList" :key="val.id" style="width: 100px;position: relative;">
          <img
            style="max-width: 100px;
            height: 30px;top: 31%;
             position: absolute;"
            :src="val.pcImgUrl"
            alt=""
          />
        </span>
        <i class="nav-underline" :style="navLineStyle"></i>
      </nav>
    </div>
    <div class="rightContent">
       <el-button style="margin-right: 25px" @click="up2YunZhou">切换新版</el-button>
      <!-- 店铺相关 -->
      <div class="head">
        <!-- <img
          src="../assets/newHomeIcon/morentouxiang.svg"
          alt
          style="width: 32px;height: 32px;border-radius: 24px"
        />-->
        <img src="../assets/newHomeIcon/icon_user.png" alt style="vertical-align: middle" />
        <div class="head_showInfo">
          <span class="head-name">
            <span
              @click="toShop"
              class="head-name-tit"
              style="
                display: inline-block;
                vertical-align: middle;
                padding: 0 4px;
              "
              >{{ this.$store.getters.loginUserInfo.shopTitle }}</span
            >
          </span>
          <i style="color: #fff; position: relative; vertical-align: middle" class="el-icon-arrow-down"></i>
          <!-- <img src="../assets/newHomeIcon/xia.png" alt style="position: relative;margin-left:5px" /> -->

          <!-- 弹出页面 -->
          <div class="hoverElement">
            <div class="top" style="left: 215px">
              <img src="../assets/newHomeIcon/top.png" alt />
            </div>
            <div class="userInfo">
              <div class="qiehuan" @click="switchStore">
                <span v-if="accountSwitches" class="switch"> 切换 </span>
                <span v-if="!accountSwitches" class="accomplish"> 完成 </span>
              </div>
              <div class="headImg">
                <img :src="picImg" alt />
              </div>
              <!-- <el-tooltip
                :content="
                  softwarename || this.$store.getters.loginUserInfo.shopTitle
                "
                placement="bottom"
                effect="light"
              > -->
              <div class="shopName" @click="toShop">
                {{ softwarename || this.$store.getters.loginUserInfo.shopTitle }}
              </div>
              <!-- </el-tooltip> -->

              <div class="vesion" v-if="subscribeType == 1">标准版</div>
              <div class="vesion" v-if="subscribeType == 2">
                高级版
              </div>
              <div
                class="vesion"
                v-if="subscribeType == 3"
                style="background: linear-gradient(90deg, #8274EF 0%, #E277B1 100%); color: white; border: 0px"
              >
                美妆版
              </div>
              <div class="line"></div>
              <div v-if="accountSwitches" style="height: 200px;margin-top:10px">
                <div class="text">剩余短信/条</div>
                <div class="num">
                  {{ this.$store.getters.loginUserInfo.paySmsTotal - this.$store.getters.loginUserInfo.useSmsTotal || "--" }}
                  <div class="button" @click="toRecharge" style="float: right">
                    充值
                  </div>
                  <div class="xiantiao"></div>
                </div>
                <!-- Note---富信短信条数 -->
                <div class="text">剩余富信/条</div>
                <div class="num">
                  {{ fuxinSms || "--" }}
                  <div class="button" @click="toRecharge1" style="float: right">
                    充值
                  </div>
                  <div class="xiantiao"></div>
                </div>
                <div class="text">剩余卡片短信/条</div>
                <div class="num">
                  {{
                    this.$store.getters.loginUserInfo.payCardSmsTotal -
                      this.$store.getters.loginUserInfo.useCardSmsTotal || "--"
                    }}
                  <div class="button" @click="toRecharge2" style="float: right">
                    充值
                  </div>
                  <div class="xiantiao"></div>
                </div>
                <!-- 标准版 -->
                <div class="text1">标准版软件有效期/天</div>
                <div class="num1">
                  {{ daysSoft }}
                  <a href="https://fw.jd.com/main/detail/FW_GOODS-1631?rdct=true" target="_blank">
                    <div class="button" style="float: right">续费</div>
                  </a>
                </div>
                <div class="time">有效期至：{{ invalidateDate || "--" }}</div>
                <!-- 高级版 -->
                <div class="text1">高级版软件有效期/天</div>
                <div class="num1">
                  {{ preDaysSoft }}
                  <a href="https://fw.jd.com/main/detail/FW_GOODS-1631?rdct=true" target="_blank">
                    <div class="button" style="float: right">续费</div>
                  </a>
                </div>
                <div class="time">有效期至：{{ preInvalidateDate || "--" }}</div>
                <!-- <div class="xiantiao"></div> -->
                <div class="setting" @click="toSetting">设置</div>
                <div class="callkf1" @click="log_out">退出登录</div>
                <!-- <div class="callkf" @click="log_out">退出登录</div> -->
              </div>

              <div class="switch" v-else>
                <div v-for="(item, index) in switchListStore" :key="index" class="switch-body1">
                  <div class="switch-content">
                    <img style="margin-right: 10px" src="../assets/newHomeIcon/morentouxiang.png" alt />
                    <span>{{ item.shopName }}</span>
                  </div>
                  <span class="toggle1" @click="toggleSwitch(item)">切换</span>
                </div>
                <div v-if="switchList.length == 0" class="switch-body toBindShop_par">
                  <div class="noimagesBox">
                    <img src="../assets/newHomeIcon/noimagesimg.png" alt style="width: 108px; height: 108px; margin: 0px 0 0 50px" />
                  </div>
                  <div class="toBindShop" @click="toBindShop">去店铺绑定</div>
                </div>
                <!-- <div v-if="switchList.length != 0" class="xiantiao"></div> -->
                <div class="setting" @click="toSetting">设置</div>
                <div class="callkf1" @click="log_out">退出登录</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- ? -->
      <!-- 换肤 -->
      <!-- <div class="changeSkin">
        <img
          src="@/assets/newHomeIcon/pi.png"
          alt
          style="width: 20px; height: 20px; position: relative; top: 5px"
        /> -->
      <!--换皮肤-->
      <!-- 换肤调色板 -->
      <!-- <el-color-picker
          v-model="theme"
          class="theme-picker"
          popper-class="theme-picker-dropdown"
          style="position: relative; top: -40px"
        ></el-color-picker>
      </div> -->
      <el-button style="margin-right: 25px" class="jiuban_button" @click="handlePlatform">切换平台</el-button>
      <!-- <el-button
        style="margin-right: 25px"
        class="jiuban_button"
        @click="toOldVersion"
        ><img
          src="@/assets/images/home/fanhui.png"
          style="
            display: inline-block;
            float: left;
            width: 14px;
            height: 14px;
            color: #ffffff;
            margin: 0 4px 0 3px;
          "
        />返回旧版</el-button
      > -->
    </div>

    <!-- 生效弹窗列表 -->
    <!-- <el-dialog title="公告内容" :visible.sync="DialogVisible">
      <div v-html="linkContents"></div>
    </el-dialog> -->
    <el-dialog
      title="公告内容"
      :close-on-click-modal="false"
      :append-to-body="true"
      :visible.sync="isPopVisiv"
      width="800px"
      :class="{ dialongTransition12: popItem.type == 0 }"
    >
      <div style="display: flex;justify-content: center;" v-if="popItem.type == 0">
        <div style="position: relative;">
          <img @click="handleUrl" class="pointer" :src="popItem.pcPic" alt style="max-width:100%;margin: 0 auto;margin-top: 38px;" />
          <img
            class="pointer"
            style="position: absolute;"
            @click="isPopVisiv = false"
            src="@/assets/images/btn_关闭.png"
            alt=""
            width="29"
            height="29"
          />
        </div>
      </div>
      <template v-else>
        <div style="height: 500px;overflow-y: auto;padding-bottom: 20px;" v-html="popItem.richText"></div>
      </template>
    </el-dialog>
  </div>
</template>
<script>
import { mapState, mapMutations } from "vuex";
import shieldList from "@/utils/shield.js";
import { loginController } from "@/api/activityController";
import { getSellerInfo, getShopInfo, switchShop, returnOldSystem, getMenuList, getSeller, homeController,up2YunZhou } from "@/api/sellerController";
import { querySellerSetting } from "@/api/backstage/a_setting";
import { logout } from "@/api/login";
import axios from "axios";
import {
  getSysConfigByKe
} from "@/api/manage/memberCrowdController";

// import { cutHostToSonShop } from "@/api/login";
export default {
  name: "page-header",
  props: {
    paths: {
      type: Array,
      require: true,
    },
  },

  watch: {
    paths(newVal, oldVal) {
      // console.log("this.paths:", this.paths);
      if (this.paths && this.paths.length > 0) {
        // console.log("watch: path:", this.paths);
        let ind = this.paths[0].index;
        this.topActive = ind;
        // console.log(this.topActive);
        if (this.topActive == 5 && this.$route.query.venderId) {
          this.loginEvent();
        }
        // if (this.once === false) {
        //只需要刷新的时候调用一次
        this.bus.$emit("topActive", { index: ind, item: this.headItem[ind] });
        this.$nextTick(() => {
          this.activeNavStyle = this.getNavStyle(this.topActive);
          // console.log('this.activeNavStyle', this.activeNavStyle)
        });

        // this.once = true;
        // }
        // this.$forceUpdate();
      }
    },
  },
  data() {
    return {
      //Note--剩余富信短信
      fuxinSms:'',
      isPopVisiv: false,

      popItem: {},
      popList: [],
      topActive: 0,
      once: false,
      //实时信息数据
      softwarename: "",
      theme: "",
      switchList: [],
      softwareInfo: {
        versionName: "POP版",
      },
      accountSwitches: true,
      activeNavStyle: { left: 0, width: 0 },
      currentNavStyle: null,
      screenWidth: document.body && document.body.clientWidth, // 屏幕尺寸
      venId: null, //商家编号
      navIogo: false,
      pathList: [],
      permissionPath: JSON.parse(localStorage.getItem("permissionPath")) || []
    };
  },
  computed: {
    ...mapState({
      globalBG: "globalBG",
      switchListStore: "switchList",
    }),
    venderType() {
      // 是否为自营店铺
      return this.$store.getters.loginUserInfo.venderType;
    },
    // 订购类型
    subscribeType() {
      return this.$store.getters.loginUserInfo.subscribeType;
    },
    headItem() {
      return this.$store.state.route;
    },
    navLineStyle() {
      let style = this.currentNavStyle || this.activeNavStyle;
      return {
        width: `${style.width}px`,
        left: `${style.left}px`,
      };
    },
    picImg() {
      var defaultImg = require("@/assets/images/home/header.png");

      var img = defaultImg;
      if (this.$store.getters.loginUserInfo && this.$store.getters.loginUserInfo.picPath) {
        img = this.$store.getters.loginUserInfo.picPath;
      }
      return img;
    },
    invalidateDate() {
      var invalidateDate = this.$store.getters.loginUserInfo.standardInvalidateDate;
      if (invalidateDate) {
        invalidateDate = invalidateDate.substr(0, 10);
      }
      return invalidateDate;
    },
    daysSoft() {
      var str = "--";
      var invalidateDate = this.invalidateDate;
      if (invalidateDate) {
        str = this.daysBetween(invalidateDate, this.getTodayYMD()) - 1;
      }
      return str;
    },
    preInvalidateDate() {
      var preInvalidateDate = this.$store.getters.loginUserInfo.premiumEditionInvalidateDate;
      if (preInvalidateDate) {
        preInvalidateDate = preInvalidateDate.substr(0, 10);
      }
      return preInvalidateDate;
    },
    preDaysSoft() {
      var str = "--";
      var preInvalidateDate = this.preInvalidateDate;
      if (preInvalidateDate) {
        let testDate = this.daysBetween(preInvalidateDate, this.getTodayYMD());
        str = ((testDate < 1) && (testDate >= 0)) ? 0 :  (testDate);
      }
      return str;
    },
  },
  mounted() {
    this.bus.$on("topHeader", (obj) => {
      this.topTab(obj.index, obj.item);
    });
    // console.log('mounted:777')

    console.log("location.pathname:", location.pathname);
    if (
      location.pathname !== "/login" &&
      location.pathname !== "/" &&
      location.pathname !== "/yusms/login" &&
      location.pathname !== "/yusms/redirection"
    ) {
      //  console.log('!=login:', location.pathname)
      this.getBindList();
      // 获取菜单
      this.getMenuData();
      // 顶部栏图
      this.popups();
    }
    // this.topTab();
    const that = this;
    window.onresize = () => {
      return (() => {
        // console.log('window.onresize:')
        window.screenWidth = document.body && document.body.clientWidth;
        that.screenWidth = window.screenWidth + 17; // 17 估计是滚动条的距离
        this.$nextTick(() => {
          this.activeNavStyle = this.getNavStyle(this.topActive);
        });
      })();
    };

    // if (this.topActive == 5 && this.$route.query.venderId) {
    //   this.loginEvent();
    // }
  },

  methods: {
    up2YunZhou() {
      up2YunZhou().then((res) => {
        window.location = res.data;
      });
    },
    ...mapMutations({
      editUserInfo: "LOGINUSERINFO",
      editPointUserInfo: "POINTUSERINFO",
      getSwitchList: "getSwitchList",
      saveShopInfo: "SHOPINFO",
    }),

    handleUrl() {
      if (this.popItem.pcUrl) {
        window.open(this.popItem.pcUrl, "_blank");
      }
    },
    
    handleLink(item) {
      if (item.pathType == 1) {
        window.open(item.pcPathUrl, "_blank");
      } else if (item.pathType == 2) {
        if (item.isNoGoingShow == 1 && item.popup.activityStatus == 2) {
          this.popItem = item.popup;
          this.isPopVisiv = true;
        }
        if (item.isNoGoingShow == 0) {
          this.popItem = item.popup;
          this.isPopVisiv = true;
        }
      }
    },
    popups() {
      homeController().then((res) => {
        this.popList = res.data;
        // 排序
        this.popList.sort((a, b) => {
          return a.position - b.position;
        });
        // console.log(res, 11111111111);
      });
    },
    getMenuData() {
      getMenuList().then(async (res) => {
        var routerList = res.data;
        var routerStr = JSON.stringify(routerList);
        routerStr = routerStr.replace(/title/g, "tittle");
        routerList = JSON.parse(routerStr);
        // console.log('routerList',routerList)
        // let resShopCategory =  await getSeller();
        // let shopCategory = resShopCategory.data.shopCategory;
        // let arrRes = await getSysConfigByKe({ key: "trade_shop_categroy" });
        // let arr = arrRes.data.pvalue.split(",");
        // let newArr = shopCategory.filter(item =>
        //   arr.includes(String(item))
        // );
        // let index = routerList.find(item=>item.path == '/industry')
        // if(newArr.length < 1 && index){
          
        //   routerList.splice(index,1)
        // }

        await this.routeLocal(routerList)
        localStorage.setItem("permissionPath", JSON.stringify(this.pathList))
        if(this.permissionPath.join() !== JSON.parse(JSON.stringify(this.pathList)).join()) {
          // 不关闭页面重新刷新的情况
          // 解决同一路由vue缓存机制不刷新的情况
          this.$router.push({ 
            path: this.$route.path,
            query: { timetemp: Date.parse(new Date()) }
          })
        }
        this.$store.state.route = routerList;
      });
    },

    // 将路由存在本地
    routeLocal(list) {
      list.map((item) => {
        if(!item.children) {
          if(item.path == "/home") {
            this.pathList.push("home")
          } else if(item.path == "/industryPreview") {
            this.pathList.push("industryPreview")
          } else {
            if (item.path == "goods_repurchase") { // 由于商品复购和商品复购周期分析path相同，所以将title存入用于后续判断
              this.pathList.push(item.tittle)
            }
            this.pathList.push(item.path)
          }
        } else {
          this.routeLocal(item.children)
        }
      })
    },

    //忠诚度管理登录
    toShop() {
      // let routeUrl = this.$router.resolve({
      //   path: "/backstage",
      //   query: { to: "/backstage/sms_management" },
      // });
      window.open(`https://mall.jd.com/index-${this.$store.getters.loginUserInfo.shopId}.html`, "_blank");
    },
    handlePlatform() {
      var url = "http://yei8.cn/AXsH";
      window.open(url, "_blank");
    },

    toOldVersion() {
      // 返回旧版
      returnOldSystem().then((res) => {
        if (res.code == "1") {
          var url = res.data.url + "?" + "token=" + res.data.token;
          window.location = url;
        }
      });
    },
    getBindList() {
      getSellerInfo().then((resp) => {
        // console.log(resp.data);
        this.editUserInfo(resp && resp.data);
        this.venId = resp.data.venderId;

        const name = resp.data.contactName;
        if (shieldList.indexOf(name) == -1) {
          this.navIogo = true;
        }
        getShopInfo().then((res) => {
          this.fuxinSms = res.data.digitalBalance;
          sessionStorage.setItem('fuxin',res.data.digitalBalance)
          if (res.code == "1") {
            this.saveShopInfo(res && res.data);
            var switchList = res.data.bindshop;
          
            if (switchList.length > 0) {
              var sellerNick = resp.data.sellerNick;
              // console.log("sellerNick:", sellerNick);
              switchList.forEach((item) => {
                if (item.claimer == sellerNick) {
                  item.shopName = item.hostshop;
                } else {
                  item.shopName = item.claimer;
                }
              });
              this.switchList = switchList;
              this.getSwitchList(this.switchList);
            }
          }
        });
      });
    },
    async topTab(ind, item) {
      sessionStorage.removeItem("markNum");
      sessionStorage.removeItem("markId");
      sessionStorage.removeItem("statusNames");
      // 互动营销
      if (item.path == "/interactive") {
        const res = await getSeller();
        if (res.data.isOrderHd) {
          window.open(
            "https://open-oauth.jd.com/oauth2/to_login?app_key=22AF00009B3D46B8DECBC457090B3560&response_type=code&redirect_uri=http://jdhd.tj9.co/jd-hd-web/yhd/auth/callback&state=jdShop&scope=snsapi_base",
            "_blank"
          );
          return;
        }
      }
      this.topActive = ind;
      this.activeNavStyle = this.getNavStyle(ind);
      var path = item.path;

      if (item.children && item.children[0].path) {
        path = item.path + "/" + item.children[0].path;
      }

      if (item.children && item.children[0].path && item.children[0].children && item.children[0].children[0].path) {
        path = item.path + "/" + item.children[0].path + "/" + item.children[0].children[0].path;
      }

      // console.log("path==", path);
      this.$router.push({ path: path });
      this.bus.$emit("topActive", { index: ind, item: item });
      if (item.path == "/integralCenter") {
        this.loginEvent();
      }
    },
    toOther(item){
      let path = item.children[0].path
      window.open("/yusms/"+path, "_blank");
    },
    toIndustryPreview(){
      window.open("/yusms/industryPreview", "_blank");
    },
    //登录
    loginEvent() {
      let venderId = { venderId: this.venId };
      console.log(venderId);
      // let venderId = { venderId: "10231814" };
      // loginController(venderId)
      //   .then((res) => {
      //     sessionStorage.setItem("loginValue", res.code);
      //     // console.log(res);
      //     if (res && res.code == 1) {
      //       if (
      //         res.data.appInfo.status == 1 &&
      //         res.data.orderInfo.status == 1
      //       ) {
      //         console.log("登录成功");
      //         this.editPointUserInfo(res.data.orderInfo)
      //       } else if (res.data.orderInfo.status != 1) {
      //         let routeUrl = this.$router.resolve({
      //           path: "/prizeCenter2",
      //         });
      //         window.open(routeUrl.href, "_blank");
      //         window.open("/home", "_self");
      //       } else {
      //         window.open(res.data.appInfo.authUrl, "_blank");
      //         window.open("/home", "_self");
      //       }
      //     } else {
      //       if (res.data.data.orderInfo.status != 1) {
      //         let routeUrl = this.$router.resolve({
      //           path: "/prizeCenter2",
      //         });
      //         window.open(routeUrl.href, "_blank");
      //       } else {
      //         window.open(res.data.data.appInfo.authUrl, "_blank");
      //       }
      //       window.open("/home", "_self");
      //     }
      //   })
      //   .catch((res) => {
      //     this.$message.error("积分登录失败");
      //     window.open("/home", "_self");
      //   });
    },

    toBindShop() {
      let routeUrl = this.$router.resolve({
        path: "/backstage/account/store_binding",
        // query: { to: "/account/store_binding" },
      });
      window.open(routeUrl.href, "_blank");
    },
    // 跳转到充值页面
    toRecharge() {
      // this.$router.push({ path: "/backstage" ,query: {to:'/backstage/smsmanage/charge'}});
      let routeUrl = this.$router.resolve({
        path: "/backstage",
        query: { to: "/backstage/sms_management" },
      });
      window.open(routeUrl.href, "_blank");
      // this.$router.push({ path: "sms_management"});
      // this.$router.push("/integralCenter/shopDecoration");
    },
    toRecharge1() {
      let routeUrl = this.$router.resolve({
        path: "/backstage",
        query: { to: "/backstage/sms_management",id:1},
      });
      window.open(routeUrl.href, "_blank");
    },
    toRecharge2() {
      let routeUrl = this.$router.resolve({
        path: "/backstage",
        query: { to: "/backstage/sms_management",id:2},
      });
      window.open(routeUrl.href, "_blank");
    },
    //去设置页面
    toSetting() {
      let routeUrl = this.$router.resolve({
        path: "/backstage",
        query: { to: "/backstage/account/account" },
      });
      window.open(routeUrl.href, "_blank");
    },
    switchStore() {
      this.accountSwitches = !this.accountSwitches;
    },
    //退出登录
    log_out() {
      logout().then((res) => {
        // this.$router.push({
        //   path: "/login",
        // });
        location.href = res.data
        // "https://passport.jd.com/oauth/login?platform_id=1&app_id=D6051BB72B5192728A55652FDC6A4564&app_name=5LqR55%2Bt5L%2BhX0NSTV%2Fnn63kv6HlhbPmgIBfX%2BefreS%2FoeiQpemUgA%3D%3D&ReturnUrl=https%3A%2F%2Fopen-oauth.jd.com%2Foauth2%2Fauthorize%3FsessionToken%3DEd93i6DYH3XG0SCF1I85iH2Tw5UMJVbz&icon_url=%2F%2Fimg30.360buyimg.com%2Fdevcenter%2Fjfs%2Ft10174%2F205%2F1860345672%2F14732%2F541c48a4%2F59e87ecdNf8c5f4fe.png&signature=94102aec7a452f40609f4ce1cbebbadf75246d1e&nls=0&applabel=L_APP_MARKET,L_APP_H5,L_APP_OAUTH_AGREEMENT_LEVEL_THREE";
        
        // this.jquery.get("/api/login/loginTimeout", function () {
        //   location.href =
        //     "https://oauth.taobao.com/authorize?response_type=code&client_id=12666072&redirect_uri=http://tb.yusms.com/api/login/tblogin&state=1212&view=web";
        // });
      });
    },
    toggleSwitch(item) {
      if (!this.accountSwitches) {
        switchShop({ sellerNick: item.shopName }).then((res) => {
          if (res.code == "1") {
            // this.softwarename = item;
            this.getBindList();
            this.getMenuData();
            // 刷新下
            this.$router.push({
              path: "/home",
            });
            this.$router.go(0);
          } else {
            this.$message.error(res.message);
          }
        });
      }
    },
    feedback() {
      this.$emit("openWindow", true);
    },
    getNavStyle(index) {
      // console.log('this.screenWidth', this.screenWidth)
      let childNodes = this.$refs.mainHeader.childNodes;
      let width = Number(childNodes[index] && childNodes[index].clientWidth);
      let left = 0;
      if (index > 0) {
        for (let i = 0; i < index; i++) {
          if (this.screenWidth < 1370) {
            left += childNodes[i].clientWidth + 5;
          } else if (this.screenWidth > 1369 && this.screenWidth < 1572) {
            left += childNodes[i].clientWidth + 5;
          } else if (this.screenWidth > 1572 && this.screenWidth < 1800) {
            left += childNodes[i].clientWidth + 29;
          } else {
            left += childNodes[i].clientWidth + 45;
          }
        }
      }
      return { width, left };
    },

    // 求两个时间的天数差 日期格式为 YYYY-MM-dd
    daysBetween(DateOne, DateTwo) {
      var OneMonth = DateOne.substring(5, DateOne.lastIndexOf("-"));
      var OneDay = DateOne.substring(DateOne.length, DateOne.lastIndexOf("-") + 1);
      var OneYear = DateOne.substring(0, DateOne.indexOf("-"));

      var TwoMonth = DateTwo.substring(5, DateTwo.lastIndexOf("-"));
      var TwoDay = DateTwo.substring(DateTwo.length, DateTwo.lastIndexOf("-") + 1);
      var TwoYear = DateTwo.substring(0, DateTwo.indexOf("-"));

      var cha = (Date.parse(OneMonth + "/" + OneDay + "/" + OneYear) - Date.parse(TwoMonth + "/" + TwoDay + "/" + TwoYear)) / 86400000;
      return cha < 0 ? 1 : Math.abs(cha);
    },

    // 获取当前时间. 格式为：年-月-日
    getTodayYMD() {
      var date = new Date();
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var month = month < 10 ? "0" + month : month;
      var day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      var ymdStr = year + "-" + month + "-" + day;
      return ymdStr;
    },
    // handleUrl() {
    //   this.$router.push({ name: "sms_management" });
    // },
  },
};
</script>
<style lang="scss" scoped>
/deep/ .theme-picker {
  left: 5px;
  opacity: 0;
}

.rightContent {
  // max-width: 272px;
  min-width: 161px;
  top: 0;
  right: 0;
  position: absolute;
  display: flex;
  align-items: center;
  // float: right;
  font-size: 14px;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  height: 60px;
  line-height: 60px;
  text-align: center;

  .head-name {
    .head-name-tit {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      max-width: 106px;
    }
    // @media screen and (max-width: 1320px) {
    @media screen and (max-width: 1780px) {
      display: none;
    }
  }

  .message {
    min-width: 1362px;
    display: inline-block;
    position: relative;
    margin-right: 32px;
    @media screen and (max-width: 1720px) {
      display: none;
    }
    i {
      font-size: 35px;
      vertical-align: bottom;
      margin-right: 6px;
    }
    .hoverEl {
      width: 229px;
      height: 117px;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 4px 10px 0px rgba(32, 98, 231, 0.09);
      position: absolute;
      top: 65px;
      left: -74px;
      display: none;
      border-radius: 5px;
      padding-left: 14px;
      padding-right: 14px;
      padding-top: 30px;
      line-height: normal;
      text-align: left;
      .text {
        font-size: 14px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
        margin-bottom: 4px;
      }
      .num {
        font-size: 28px;
        font-family: DINAlternate-Bold;
        font-weight: bold;
        color: rgba(51, 51, 51, 1);
        .button {
          width: 72px;
          height: 26px;
          /*background: rgba(32, 98, 231, 1);*/
          /*box-shadow: 0px 3px 6px 0px rgba(32, 98, 231, 0.6);*/
          border-radius: 6px;
          font-size: 14px;
          font-family: PingFangSC-Regular;
          font-weight: 400;
          color: rgba(255, 255, 255, 1);
          line-height: 26px;
          text-align: center;
          display: inline-block;
          vertical-align: middle;
          cursor: pointer;
        }
      }
    }
  }
  .message:hover {
    .hoverEl {
      display: inline-block;
    }
  }
  .expireTime {
    display: inline-block;
    margin-right: 32px;
    position: relative;
    @media screen and (max-width: 1600px) {
      display: none;
    }
    @media screen and (max-width: 1720px) {
      display: none;
    }
    i {
      font-size: 35px;
      vertical-align: bottom;
      margin-right: 6px;
    }
    .hoverEle {
      width: 229px;
      height: 130px;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 4px 10px 0px rgba(32, 98, 231, 0.09);
      position: absolute;
      top: 65px;
      left: -74px;
      display: none;
      border-radius: 5px;
      padding-left: 14px;
      padding-right: 14px;
      padding-top: 30px;
      line-height: normal;
      text-align: left;
      .text {
        font-size: 14px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
        margin-bottom: 4px;
      }
      .num {
        font-size: 28px;
        font-family: DINAlternate-Bold;
        font-weight: bold;
        color: rgba(51, 51, 51, 1);
        .button {
          width: 70px;
          height: 28px;
          background: rgba(32, 98, 231, 1);
          box-shadow: 0px 3px 6px 0px rgba(32, 98, 231, 0.6);
          border-radius: 6px;
          font-size: 14px;
          font-family: PingFangSC-Regular;
          font-weight: 400;
          color: rgba(255, 255, 255, 1);
          line-height: 28px;
          text-align: center;
          display: inline-block;
          vertical-align: middle;
          cursor: pointer;
        }
      }
      .time {
        color: rgba(153, 153, 153, 1);
        margin-top: 10px;
      }
    }
  }
  .expireTime:hover {
    .hoverEle {
      display: inline-block;
    }
  }
  .head {
    display: inline-block;
    width: auto;
    height: 48px;
    line-height: 40px;
    vertical-align: top;
    margin-right: 15px;
    position: relative;
    margin-top: 8px;
    // @media only screen and (max-width:1440px){
    @media only screen and (max-width: 1660px) {
      margin-right: 10px;
    }
    img {
      display: inline-block;
      vertical-align: middle;
      // background-color: #fff !important;
    }
    .hoverElement {
      width: 255px;
      // height: 374px;
      height: 610px;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 4px 10px 0px rgba(32, 98, 231, 0.09);
      position: absolute;
      top: 45px;
      right: -24px;
      display: none;
      border-radius: 5px;
      padding-left: 24px;
      padding-right: 24px;
      padding-top: 18px;
      line-height: normal;
      text-align: left;
      .xiantiao {
        width: 100%;
        height: 1px;
        background: #f0f0f0;
        opacity: 1;
        margin: 12px 0;
      }
      .userInfo {
        .headImg {
          margin-top: 30px;
          width: 48px;
          height: 48px;
          border-radius: 24px;
          display: inline-block;
          img {
            width: 207px;
            height: 68px;
            border-radius: 4px;
          }
        }
        .shopName {
          width: 145px;
          font-size: 14px;
          top: 30px;
          left: -14px;
          position: relative;
          font-family: PingFangSC-Regular;
          font-weight: 600;
          color: rgba(51, 51, 51, 1);
          display: inline-block;
          vertical-align: top;
          margin-left: 14px;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
          &:hover {
            color: #fe4d45;
          }
        }
        .vesion {
          position: relative;
          left: 155px;
          top: 11px;
          width: 54px;
          height: 18px;
          background: linear-gradient(90deg, #ff4e4c 0%, #ff783f 100%);
          opacity: 1;
          border-radius: 12px;
          // width: 54px;
          padding: 2px;
          height: 20px;
          font-size: 12px;
          font-family: PingFangSC-Regular;
          font-weight: 400;
          color: #fff;
          display: inline-block;
          line-height: 15px;
          text-align: center;
          vertical-align: bottom;
        }
      }
      .callkf {
        cursor: pointer;
        height: 22px;
        line-height: 22px;
        text-align: center;
        position: absolute;
        margin: 0px 0px 0 55px;
        width: 98px;
        // height: 32px;
        font-size: 16px;
        // font-family: PingFang SC;
        font-weight: 400;
        border-radius: 3px;
        // padding: 5px 12px;
        // line-height: 21px;
        color: #999999;
      }
      .callkf:hover {
        color: #fe4d45;
      }
      .setting {
        cursor: pointer;
        height: 60px;
        line-height: 22px;
        text-align: center;
        position: absolute;
        border-top: 1px solid #f0f0f0;
        // top: 384px;
        bottom: 0px;
        left: 0px;
        width: 80px;
        font-size: 16px;
        font-weight: 400;
        padding-top: 18px;
        color: #999999;
        &:hover {
          color: #7f85e9;
        }
      }
      .callkf1 {
        cursor: pointer;
        height: 60px;
        line-height: 22px;
        text-align: center;
        position: absolute;
        border-top: 1px solid #f0f0f0;
        border-left: 1px solid #f0f0f0;
        // top: 384px;
        bottom: 0px;
        left: 79px;
        padding-top: 18px;
        width: 176px;
        font-size: 16px;
        font-weight: 400;
        color: #999999;
      }
      .callkf1:hover {
        color: #fe4d45;
      }
      .switch {
        height: 150px;
        // background: linear-gradient(90deg, #ff4e4c 0%, #ff783f 100%);
        color: #333333;
        font-size: 14px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        // height: 150px;
        overflow: auto;
        .switch-body {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 8px;
          width: 100%;
        }
        .switch-body1 {
          border-bottom: 1px solid #f0f0f0;
          padding-top: 4px;
          padding-bottom: 14px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 8px;
          width: 100%;
        }
        .switch-content {
          display: flex;
          align-items: center;
        }
        img {
          width: 32px;
          color: #709fff;
        }
        .noimagesBox {
          width: 207px;
          // height: 100px;

          background: #fff;
          // opacity: 1;
          // border-radius: 4px;
        }
        .toBindShop {
          padding: 5px 18px;
          position: absolute;
          top: 253px;
          left: 72px;
          width: 110px;
          color: #fe4d45;
          height: 32px;
          background: #fff4f4;
          border: 1px solid #fe4d45;
          opacity: 1;
          border-radius: 4px;
          &:hover {
            color: #fe4d45;
            background-color: #ffe5e5;
          }
          &:active {
            color: #fe4d45;
            border: 1px solid #fe4d45;
            background-color: #fff4f4;
          }
        }
        .toggle {
          padding: 3px 20px;
          width: 70px;
          height: 28px;
          cursor: pointer;
          color: #fe4d45;
          border: 1px solid #fe4d45;
          border-radius: 4px;
          background-color: #fff4f4;
          &:hover {
            color: #fe4d45;
            background-color: #ffe5e5;
          }
          &:active {
            color: #fe4d45;
            border: 1px solid #fe4d45;
            background-color: #fff4f4;
          }
        }
        .toggle1 {
          padding: 3px 20px;
          width: 70px;
          height: 28px;
          cursor: pointer;
          color: #7f85e9;
          border: 1px solid #7f85e9;
          border-radius: 4px;
          background-color: #f7f8fe;
          &:hover {
            color: #7f85e9;
            background-color: #f2f3fd;
          }
          &:active {
            color: #7f85e9;
            border: 1px solid #7f85e9;
            background-color: #ecedfc;
          }
        }
      }
      .qiehuan {
        cursor: pointer;
        float: right;
        opacity: 1;
        position: relative;
        top: 0px;
        i {
          font-size: 14px;
        }
        .switch {
          color: #7f85e9;
          font-size: 13px;
          font-family: PingFangSC-Regular;
          font-weight: 400;
        }
        .accomplish {
          color: #7f85e9;
          font-size: 13px;
          font-family: PingFangSC-Regular;
          font-weight: 400;
        }
      }
      .qiehuan:hover {
        opacity: 0.7;
      }

      .text {
        font-size: 12px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
        margin-bottom: 4px;
      }
      .num {
        font-size: 20px;
        font-family: DINAlternate-Bold;
        font-weight: bold;
        color: #252c38;
        .button {
          width: 70px;
          height: 28px;
          // float: right;
          font-size: 14px;
          line-height: 24px;
          text-align: center;
          display: inline-block;
          vertical-align: middle;
          cursor: pointer;
          font-weight: 400;
          color: #fe4d45;
          border: 1px solid #fe4d45;
          border-radius: 4px;
          background-color: #fff4f4;
          &:hover {
            color: #fe4d45;
            background-color: #ffe5e5;
          }
          &:active {
            color: #fe4d45;
            border: 1px solid #fe4d45;
            background-color: #fff4f4;
          }
        }
      }
      .text1 {
        font-size: 12px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: #252c38;
        margin-bottom: 4px;
        margin-top: 16px;
      }
      .num1 {
        font-size: 20px;
        font-family: DINAlternate-Bold;
        font-weight: bold;
        color: rgba(51, 51, 51, 1);
        .button {
          width: 70px;
          height: 28px;
          font-size: 14px;
          line-height: 24px;
          text-align: center;
          display: inline-block;
          vertical-align: middle;
          font-weight: 400;
          cursor: pointer;
          color: #fe4d45;
          border: 1px solid #fe4d45;
          border-radius: 4px;
          background-color: #fff4f4;
          &:hover {
            color: #fe4d45;
            background-color: #ffe5e5;
          }
          &:active {
            color: #fe4d45;
            border: 1px solid #fe4d45;
            background-color: #fff4f4;
          }
        }
      }
      .time {
        color: #7f85e9;
        margin-top: 10px;
        font-size: 12px;
      }
    }
  }
  .head_showInfo {
    display: inline-block;
    cursor: pointer;
  }
  .head_showInfo:hover {
    .hoverElement {
      display: inline-block;
    }
  }
  .help {
    display: flex;
    align-items: center;
    height: 60px;
    width: 60px;
    line-height: 60px;
    margin-right: 30px;
    .edition {
      display: inline-block;
      width: 62px;
      height: 18px;
      color: #fff;
      text-align: center;
      background: url("../assets/images/edition_bg.png") no-repeat 100% center;
      span {
        display: inline-block;
        transform: scale(0.8);
      }
    }
    // @media only screen and (max-width:1440px){
    @media only screen and (max-width: 1660px) {
      margin-right: 10px;
    }
    vertical-align: top;
  }
  .changeSkin {
    display: inline-block;
    vertical-align: bottom;
    margin-right: 20px;
    height: 60px;
    width: 32px;
  }
  .jiuban_button {
    width: 96px;
    height: 28px;
    font-size: 13px;
    font-weight: 400;
    border-radius: 4px;
    background: linear-gradient(131deg, #ff6d6e 0%, #fe333b 100%);
    color: #ffffff;
    border: none;
  }
}
.top {
  display: flex;
  justify-content: center;
  position: absolute;
  top: -14px;
  left: 110px;
  img {
    width: 20px;
    height: 20px;
  }
}
.line {
  margin-top: 20px;
  margin-bottom: 20px;
}

.customerService {
  padding: 20px;
  .title {
    height: 28px;
    font-size: 20px;
    font-family: PingFangSC-Medium;
    font-weight: 900;
    color: rgba(51, 51, 51, 1);
    line-height: 28px;
  }
  .toService {
    margin-top: 13px;
    font-size: 14px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    color: rgba(153, 153, 153, 1);
    line-height: 20px;
    .phone {
      display: inline-block;
      font-size: 14px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      color: rgba(32, 98, 231, 1);
      line-height: 20px;
      img {
        width: 28px;
        height: 28px;
        vertical-align: middle;
        margin-right: 6px;
      }
    }
  }

  .wechatService {
    margin-top: 12px;
    display: flex;
    padding: 0 10px;
    justify-content: space-between;
    .QRcode {
      width: 95px;
      height: 95px;
      background: rgba(216, 216, 216, 1);
      border: 1px solid rgba(151, 151, 151, 1);
    }
  }
}
.help {
  // margin-top: 10px;
  display: flex;
  // padding: 0 10px;
  justify-content: space-between;
  div {
    width: 96px;
    height: 28px;
    border-radius: 6px;
    font-size: 14px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    color: rgba(32, 98, 231, 1);
    line-height: 28px;
    text-align: center;
    cursor: pointer;
    i {
      vertical-align: middle;
    }
  }
  .helpTitle {
    border: none;
    width: 85px;
    color: #fff;
    line-height: 20px;
    height: 20px;
    margin-top: 5px;
    img {
      width: 11px;
      height: 11px;
      margin-left: 3px;
    }
  }
}

.container {
  height: 60px;
  width: 100%;
  transition: all 0.5s;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;
  .logo {
    box-sizing: border-box;
    width: 170px;
    background: rgba(254, 77, 69, 1);
    opacity: 1;
    vertical-align: top;
    display: inline-block;
    height: 60px;
    line-height: 65px;
    @media screen and (min-width: 1500px) and (max-width: 1700px) {
      line-height: 68px;
    }
    @media screen and (min-width: 1400px) and (max-width: 1499px) {
      line-height: 69px;
    }
    @media screen and (max-width: 1399px) {
      line-height: 70px;
    }
    padding: 5px 0;
    text-align: center;
    img {
      display: inline-block;
      margin-top: -22px;
      // width: 140px;
      @media screen and (max-width: 1366px) {
        margin-top: -24px;
      }
      // height: 40px;
      vertical-align: middle;
    }
    img:after {
      content: "";
      display: inline-block;
      vertical-align: middle;
    }
  }
  .module {
    display: inline-block;
    margin-left: 20px;
    @media screen and (min-width: 1440px) {
      margin-left: 0;
    }
    .nav {
      margin-left: 20px;
      display: inline-flex;
      position: relative;
      height: 60px;
      line-height: 72px;
      overflow: hidden;
      .nav-item {
        position: relative;
        padding: 0 10px;
        margin-right: 45px;
        bottom: 5px;
        color: #d5d6de;
        font-size: 16px;
        cursor: pointer;
        &:hover::before {
          bottom: -5px;
          opacity: 1;
          // @media screen and (max-width: 1300px) {
          //   bottom: -2px;
          // }
        }
        &::before {
          content: "";
          position: absolute;
          bottom: -11px;
          left: 0;
          width: 100%;
          height: 4px;
          background-color: #555a7a;
          border-radius: 8px 8px 0 0;
          // opacity: 0;
          // transition: 0.3s;
        }
      }
      .nav-pcImgUrl {
        padding: 0;
        &::before {
          background-color: transparent !important;
        }
      }
      .navLeft {
        margin-left: -45px;
      }
      .nav-underline {
        position: absolute;
        bottom: 0;
        margin-left: 2px;
        display: block;
        height: 4px;
        top: 56px;
        border-radius: 8px 8px 0 0;
        background-color: #fe4d45;
        transition: all 0.4s ease-in-out;
      }
      .navActive {
        color: #fff;
      }
      // .nav-item.navActive {
      //   // &::before {
      //   //   bottom: 0;
      //   //   opacity: 1;
      //   //   background-color: #FE4D45;
      //   // }
      // }
    }
    .item {
      position: relative;
      display: inline-block;
      font-size: 16px;
      font-weight: 400;
      color: #d5d6de;
      line-height: 30px;
      text-align: center;
      margin-left: 64px;
      cursor: pointer;
      height: 30px;
      &:hover {
        color: white;
        &::before {
          content: "";
          width: 150%;
          background-color: #555a7a;
          height: 4px;
          font-size: 16px;
          position: absolute;
          bottom: -11px;
          border-radius: 4px;
          left: -50%;
          transform: translateX(18%);
        }
      }
    }
    .active {
      width: 150%;
      background-color: #fe4d45;
      height: 4px;
      font-size: 16px;
      position: absolute;
      bottom: -11px;
      border-radius: 4px;
      left: -50%;
      transform: translateX(18%);
    }
    .item.tabActive {
      color: #fff !important;
    }
  }
}

.headerContactBox {
  padding: 20px 10px !important;
  .info {
    padding: 0 9px 17px 9px;
    border-bottom: 1px solid #f3f3f3;
    color: #333;
    font-size: 14px;
    .labelTxt {
      display: inline-block;
      width: 65px;
    }
    .btnContact {
      position: relative;
      margin-left: 6px;
      padding: 0 15px;
      line-height: 20px;
      height: 20px;
      border-radius: 2px;
      border: 1px solid #ccc;
      background: #fff;
      font-size: 14px;
      color: #999;
      cursor: pointer;
      transition: all 0.2s linear;
      outline: none;
      .hoverIcon {
        position: absolute;
        left: 15px;
        top: 3px;
        opacity: 0;
      }
      &:hover {
        color: #5882fb;
        border: 1px solid #5882fb;
        background: rgba(88, 130, 251, 0.1);
        .icon {
          opacity: 0;
        }
        .hoverIcon {
          width: 13px;
          height: 13px;
          opacity: 1;
        }
      }
    }
  }
  .foot {
    display: flex;
    justify-content: space-between;
    margin-top: 14px;
    .btn {
      width: 110px;
      height: 28px;
      line-height: 26px;
      border: 1px solid #ccc;
      color: #999;
      border-radius: 2px;
      cursor: pointer;
      transition: all 0.2s linear;
      display: flex;
      align-items: center;
      justify-content: center;
      &:hover {
        color: #5882fb;
        background: rgba(88, 130, 251, 0.1);
        border: 1px solid rgba(88, 130, 251, 1);
      }
      &:active {
        color: #3d6fff;
        background: rgba(88, 130, 251, 0.1);
        border: 1px solid rgba(61, 111, 255, 1);
      }
    }
  }
}
@media screen and (min-width: 1572px) and (max-width: 1800px) {
  .container {
    .module {
      .nav {
        .nav-item {
          margin-right: 29px;
        }
        .navLeft {
          margin-left: -29px;
        }
      }
    }
  }
}
@media screen and (min-width: 1369px) and (max-width: 1572px) {
  .container {
    .module {
      .nav {
        .nav-item {
          margin-right: 5px;
        }
        .nav-pcImgUrl {
          margin-right: 15px;
        }
        .navLeft {
          margin-left: -5px;
        }
      }
    }
  }
}
@media screen and (max-width: 1369px) {
  .container {
    .module {
      .nav {
        .nav-item {
          margin-right: 5px;
        }
        .nav-pcImgUrl {
          margin-right: 15px;
        }
        .navLeft {
          margin-left: -5px;
        }
      }
    }
  }
}
</style>

<style lang="scss">
.dialongTransition12 {
  .el-dialog {
    background: transparent;
    box-shadow: none !important;
    // box-shadow: 0 0px 0px rgba(0, 0, 0, 0.3);
    .el-dialog__header {
      display: none;
    }

    .el-dialog__body {
      background: transparent;
    }
  }
}
</style>
